import { useEffect, useState } from "react";
import { Container, Row, Col, Modal, FormSelect, FormControl } from "react-bootstrap";
import '../../../assets/styles/styles.css';

import zoomIcon from '../../../assets/images/zoom_icon.svg'
import bonezIcon from '../../../assets/images/bonez_icon.svg'

import { playSound, handleClickSound } from "../../game/scenes/classes/PlaySound";

export default function CreateGameModal(props) {

    const parseBalance = (balance) => {
        if (typeof balance === 'number') return balance;
        return parseInt(balance.replace(/[^\d]/g, ''), 10) || 0;
    };

    return (
        <Modal show={props.showModal} onShow={() => { props.setWagerType("bonez"); props.setPotAmount(2); }} onHide={() => { props.setShowModal(false) }} centered>
            <div className="whole-container">
                <Row style={{ marginBottom: "2%" }}>
                    <h1 className="container-title" style={{ color: '#BD00FF' }}>Choose your wager to create a new game</h1>
                </Row>
                <Row style={{ marginBottom: "2%" }}>
                    <Col lg={6} sm={6}>
                        <div style={{ textAlign: "center" }}>
                            <h1 className="container-body-text" style={{ display: "inline-block", marginRight: "2rem" }}>Play for: </h1>
                        </div>
                    </Col>
                    <Col lg={6} sm={6}>
                        <FormSelect className="form-select" value={props.wagerType} onChange={(event) => {props.setWagerType(event.target.value); event.target.value === "zoom" ? props.setPotAmount(5000) : props.setPotAmount(2)}}>
                            <option value="bonez">Bonez</option>
                            <option value="zoom">Chipz</option>
                        </FormSelect>
                    </Col>
                </Row>
                <Row style={{ marginBottom: "2%" }}>
                    <Col lg={6} sm={6}>
                        <div style={{ textAlign: "center" }}>
                            <h1 className="container-body-text" style={{ display: "inline-block", marginRight: "2rem" }}>Wager amount: </h1>
                        </div>
                    </Col>
                    <Col lg={6} sm={6}>
                        <FormControl className="wager-form-control" type="number" placeholder="Wager" value={props.potAmount} onChange={(event) => {
                            //check maximum and minimum pot values
                            if (event.target.value > 4999999999) {
                                props.setPotAmount(4999999999);
                            }
                            else if (event.target.value < 0) {
                                props.setPotAmount(0);
                            }
                            else {
                                props.setPotAmount(parseInt(event.target.value))
                            }
                        }
                        } />
                    </Col>
                </Row>
                <Row style={{ marginBottom: "2%" }}>
                    <div>
                        {/* <h1 className="container-body-text" style={{ color: "#BD00FF", display: "inline-block" }}>Total Wager: </h1> */}
                        {props.wagerType === "zoom" ?
                            <img
                            className="chipz-icon stat-icon"
                            title="Zoombies Chipz"
                            src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                            alt="Chipz icon"
                            style={{ display: "inline-block", marginLeft: "0.5rem", marginRight: "0.5rem", marginBottom: "0.5rem" }} /> :
                            <img src={bonezIcon} width="38px" height="45px" style={{ display: "inline-block", marginLeft: "0.5rem", marginRight: "0.5rem", marginBottom: "0.5rem" }} />
                        }
                        {props.wagerType === "zoom" ?
                            <h1 className="container-body-text" style={{ color: "#FFFFFF", display: "inline-block" }}>{!Number.isNaN(parseInt(props.potAmount)) ? props.potAmount.toLocaleString('en-US') : 0} Chipz</h1> :
                            <h1 className="container-body-text" style={{ color: "#FFFFFF", display: "inline-block" }}>{!Number.isNaN(parseInt(props.potAmount)) ? props.potAmount.toLocaleString('en-US') : 0} Bonez</h1>
                        }
                    </div>
                </Row>
                <Row style={{ marginBottom: "2%" }}>
                    <button
                        className={`button create-game-modal
                            ${((props.wagerType === "zoom" && props.potAmount > props.zoomBalance) ||
                                (props.wagerType !== "zoom" && props.potAmount > parseBalance(props.bonezBalance)) ||
                                (Number.isNaN(parseInt(props.potAmount))) ||
                                (props.potAmount < 5000 && props.wagerType === "zoom") ||
                                (props.potAmount < 2 && props.wagerType !== "zoom"))
                            && "button-disabled"}`
                        }
                        style={{ width: "50%", height: "50px" }}
                        onClick={() => {
                            props.createGame();
                            playSound("clickSound");
                        }}
                        disabled={(props.wagerType === "zoom" && props.potAmount > props.zoomBalance) || (props.wagerType !== "zoom" && parseInt(props.potAmount) > parseBalance(props.bonezBalance))}
                    >
                        <audio id="clickSound" className="sound-fx" hidden>
                            <source src="/bonez/sounds/click.mp3" type="audio/mp3"/>
                            Your browser does not support the audio element.
                        </audio>
                        <img
                            className="create-game-button-image"
                            src="https://zoombies.world/images/dapp/green_button_500.webp"
                            alt=""
                        />
                        <span
                            className="button-text game-modal create-game-button-text"
                            style={
                                ((props.wagerType === "zoom" && props.potAmount > props.zoomBalance) ||
                                (props.wagerType !== "zoom" && props.potAmount > parseBalance(props.bonezBalance)))
                                ? { fontSize: "1.3em" }  // Adjust this value as needed
                                : {}
                            }
                        >
                            {((props.wagerType === "zoom" && props.potAmount > props.zoomBalance) || (props.wagerType !== "zoom" && props.potAmount > parseBalance(props.bonezBalance)))
                                ?
                                "INSUFFICIENT BALANCE" :
                                "CREATE GAME"
                            }
                        </span>
                    </button>
                </Row>
                <Row>
                    {props.wagerType === "zoom" && (Number.isNaN(parseInt(props.potAmount)) || props.potAmount < 5000)  &&
                        <h1 className="container-body-text" style={{ color: "#FF0000" }}>Minimum wager is 5000 Chipz</h1>
                    }
                    {props.wagerType === "bonez" && (Number.isNaN(parseInt(props.potAmount)) || props.potAmount < 2) && 
                        <h1 className="container-body-text" style={{ color: "#FF0000" }}>Minimum wager is 2 Bonez</h1>
                    }
                    <div className="disclaimer">
                        <p className="disclaimer-text">
                            By creating a game you understand that your wager will be added to the game pot & will be lost to your opponent if you abandon or lose the game.
                            <br/><br/>10% will be deducted from the pot (Chipz games only) for the Treasury
                        </p>
                    </div>
                </Row>
            </div>
        </Modal>
    )
}